import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Row, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

/**
 * Protects routes by role. Uses AuthContext so we wait for auth to be ready
 * before deciding; avoids 401 when opening a link directly (e.g. MessageDetails)
 * because we no longer race with session restore.
 */
const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
    const { isLoading: authLoading, userGroups } = useAuth();

    if (authLoading) {
        return (
            <Row>
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </Row>
        );
    }

    const isAuthorized = Array.isArray(userGroups) && userGroups.length > 0 &&
        userGroups.some(role => allowedRoles && allowedRoles.includes(role));

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthorized ? <Component {...props} /> : <Redirect to="/401-page" />
            }
        />
    );
};

export default PrivateRoute;
